import React from 'react'
import ErrorSnackbar from 'components/shared/snackbars/ErrorSnackbar'

interface ErrorMessageProps {
    show: boolean,
    onClickClose: () => void,
    text: string
}

class ErrorMessage extends React.Component<ErrorMessageProps> {

    state = {
        open: false,
        text: ''
    }

    shownPropChanged = (prevProps) => prevProps.show !== this.props.show

    errorMessageShouldBeShown = (prevProps) => this.shownPropChanged(prevProps) && this.props.show

    errorMessageShouldBeHidden = (prevProps) => this.shownPropChanged(prevProps) && !this.props.show

    textChanged = (prevProps) => prevProps.text !== this.props.text

    componentDidMount() {
        if(this.props.show) {
            this.setState({ open: true, text: this.props.text })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.errorMessageShouldBeShown(prevProps)) {
            this.setState({
                open: true,
                text: this.props.text
            })
        }

        if (this.errorMessageShouldBeHidden(prevProps)) {
            this.setState({
                open: false
            })
        }

        if (this.textChanged(prevProps) && !this.errorMessageShouldBeHidden(prevProps)) {
            this.setState({
                text: this.props.text
            })
        }
    }

    render() {
        return (
            <ErrorSnackbar
                onClickClose={this.props.onClickClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={this.state.open}
                message={this.state.text}
            />
        )
    }
}

export default ErrorMessage